// extracted by mini-css-extract-plugin
export var actionButton = "_x3-2";
export var card = "_x3-0";
export var disambiguationList = "_x3-3";
export var errorCard = "_x3-4";
export var row = "_x3-1";